import './App.css';
import { observer } from "mobx-react-lite";
import React from "react";
import ScaleManager from 'react-sdk/ScaleManager';
import AppState, { POPUPS, SCREENS } from "@/js/AppState";

import ScreenLoading from "@scr/ScreenLoading/ScreenLoading";
import ScreenHome from "@scr/ScreenHome/ScreenHome";
import Notifs from "@cmp/shared/Notifs/Notifs";
import ScreenVideo from '@scr/ScreenVideo/ScreenVideo';
import ScreenGame from "@scr/ScreenGame/ScreenGame";
import PopupsManager from 'react-sdk/PopupsManager';
import PopupNotif from '@pops/PopupNotif/PopupNotif';
import ScreenModules from '../screens/ScreenModules/ScreenModules';
import PopupMentionsLegales from '../popups/PopupMentionsLegales/PopupMentionsLegales';
import AudioButton from '../Hud/AudioButton/AudioButton';
import ScreenEnd from '../screens/ScreenEnd/ScreenEnd';

const App = () => {
  return (
    <>
      <div className="App"  style={ScaleManager.style}>
        {AppState.screen === SCREENS.LOADING && <ScreenLoading />}

        {AppState.screen === SCREENS.HOME && <ScreenHome />}
        {AppState.screen === SCREENS.MODULES && <ScreenModules />}

        {AppState.screen === SCREENS.VIDEO && <ScreenVideo />}
        {AppState.screen === SCREENS.GAME && <ScreenGame />}

        
        {AppState.screen === SCREENS.ECRAN_FINAL && <ScreenEnd />}



        {PopupsManager.isOpened(POPUPS.MENTIONS_LEGALES) &&
        <PopupMentionsLegales />}
 
        <Notifs />
      </div>
    </>
  )
}

export default observer(App);
